document.addEventListener('DOMContentLoaded', () => {
  const targets = document.querySelectorAll('.js-fade-in, .fade-item, .js-fade-in-sp, .js-pop-in, .js-nyuun-in');

  if (!targets.length) return;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2,
    rootMargin: '0px 0px -10% 0px'
  });

  targets.forEach(el => observer.observe(el));
});



document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelectorAll('.jdgm-prev-badge__text').forEach(el => {

      // 商品詳細エリア内はそのまま表示
      if (el.closest('.product-details')) return;

      const pos = el.textContent.indexOf('｜');

      if (pos !== -1) {
        el.textContent = el.textContent.substring(0, pos);
      }

      if (el.textContent.includes('レビューはまだありません')) {
        el.textContent = '';
      }
    });
  }, 1000);
});
